export default {
    setCards: (state, cards) => { state.cards = cards },
    setCardsProgress: (state, cardsProgress) => { state.cardsProgress = cardsProgress },
    setDeviceRecentlySeen: (state, deviceRecentlySeen) => { state.deviceRecentlySeen = deviceRecentlySeen || [] },
    setFavorites: (state, favorites) => { state.favorites = favorites || [] },
    setFavoritesIssued: (state, favoritesIssued) => { state.favoritesIssued = favoritesIssued },
    setHomeRecommendations: (state, homeRecommendations) => { state.homeRecommendations = homeRecommendations },
}
